import styled, { css } from 'styled-components';

export const Container = styled.div`
  height: calc(100vh - 8rem);
  width: 100%;
  margin-top: 4rem;
  background-color: var(--gray-background);
  align-items: center;
  justify-content: center;
  display: flex;
  ${props => props.nonUserRoute && css`
    height: calc(100vh - 4rem);
    margin-top: 0;
  ` };

  @media (max-width: 850px) {
    height: calc(100vh - 4rem);
  }

`;

export const Content = styled.div`
  padding: 2rem 0;
  height: calc(100vh - 8rem);
  width: 70%;
  max-width: 1400px;
  
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  font-size: 1rem;

  @media (min-width: 1500px) {
    .body {
      margin-top: 4rem;
    }
    font-size: 1.4rem;
  }

  img {
    width: 90%;
    max-width: 30rem;
    height: auto;
    padding-bottom: 2rem;
  }

  .body {
    overflow: auto;
    display: flex;
    gap: 4rem;

    .right-side {
      width: 28%;
      max-width: 320px;
      .participants {
        max-height: 65%;
        overflow: auto;
      }

    }

    .left-side {
      flex: 1;
      p {
        text-align: justify;
      }
    }

    @media (max-width: 700px) {
      flex-direction: column;
      .right-side {
        flex: 1;
        white-space: nowrap;
        .participants {
          overflow: unset;
        }

      }

    }
    
  }

  
`;
